module.exports = __webpack_public_path__ + "img/accessory_item_10.ed9ab625.svg";